import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST_COUNT } from "../types";
import generateError from "../../../utilities/generateError";

import {
  getWatchListEntriesByWatchListCountPending,
  getWatchListEntriesByWatchListCountFulfilled,
  getWatchListEntriesByWatchListCountRejected,
} from "../actions";

import { sendApiRequest, notifyWarning, notifyError } from "../../../actions";
import { WATCH_LIST_ENTRY_MESSAGES } from "../constants/watchListEntryMessages";

const createPayload = (payload) => ({
  method: "get",
  url: "watchlistentry/count",
  onSuccess: [
    (response) =>
      response.data === 0
        ? notifyWarning(WATCH_LIST_ENTRY_MESSAGES.NOT_FOUND)
        : { type: "" },
    (response) => getWatchListEntriesByWatchListCountFulfilled(response),
  ],
  onError: [
    getWatchListEntriesByWatchListCountRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getWatchListEntriesByWatchListCountEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST_COUNT.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(getWatchListEntriesByWatchListCountPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default getWatchListEntriesByWatchListCountEpic$;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/getWatchListEntriesByWatchListCountEpic.js